<template>
    <v-app id="eventionAdminPortal">
        <AppDrawer color="primary" v-if="!loginDialogShown && loggedInUser && loggedInUser.email != 'api@eventionapp.com' && loggedInUser.email != 'pbc2024@eventionapp.com'" v-model="drawerShown" ></AppDrawer>

        <v-app-bar app class="primary" clipped-left v-if="!loginDialogShown && loggedInUser && loggedInUser.email != 'api@eventionapp.com' && loggedInUser.email != 'pbc2024@eventionapp.com'"  >
            <v-app-bar-nav-icon color="white" v-if="!loginDialogShown" @click.stop="drawerShown = !drawerShown"></v-app-bar-nav-icon>
            <v-toolbar-title @click="$router.push({name: 'landing'})" style="cursor: pointer" class="pl-2 mt-n1">
                <v-img src="/evention-logo.png" max-width="150" height="30" contain>  
                </v-img>
            </v-toolbar-title>
            <v-toolbar-title class="pl-7" v-show="$vuetify.breakpoint.smAndUp">
                <span id="hash-name"></span><span id="event-name"></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-title>{{loggedInUser ? loggedInUser.email.split('@')[0] : ''}}</v-toolbar-title>
            <!-- <v-avatar v-if="!loginDialogShown">
                <v-icon>mdi-account-circle</v-icon>
            </v-avatar> -->
            <v-avatar>
                <v-icon color="white" @click="logout" v-if="!loginDialogShown">mdi-logout</v-icon>
            </v-avatar>
        </v-app-bar>

        <v-content>
            <v-container v-if="!loginDialogShown" fluid>
                <router-view></router-view>
                <div style="height: 100px;"></div>
            </v-container>

            <v-container class="primaryBackgroundColor" fill-height fluid v-if="loginDialogShown">
                <v-row class="mx-auto">
                    <v-col cols="12">
                        <v-card outlined class="mx-auto" max-width="400">
                            <v-card-title class="my-5 mx-2" :class="{'my-5': $vuetify.breakpoint.smAndUp, 'mx-10': $vuetify.breakpoint.smAndUp}">
                                <v-img
                                    src="/evention_logo_black.png"
                                    max-width="200"
                                    class="mx-auto">
                                </v-img>
                            </v-card-title>
                            <v-card-text>

                                <v-form>
                                    <v-container class="px-5 py-5" >
                                        <v-row>
                                            <v-text-field class="loginLabel py-5"
                                                        :label="$t('login.username')"
                                                        prepend-icon="mdi-account"
                                                        v-model="username"
                                                        placeholder=" "></v-text-field>
                                        </v-row>
                                        <v-row>
                                            <v-text-field class="loginLabel py-5"
                                                        :label="$t('login.password')"
                                                        v-model="password"
                                                        prepend-icon="mdi-lock-question"
                                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                        :type="showPassword ? 'text' : 'password'"
                                                        placeholder=" "
                                                        @click:append="showPassword = !showPassword"></v-text-field>
                                        </v-row>
                                    </v-container>
                                    <ReCaptcha class="px-5" @reCaptchaResponse="updateReCaptchaResponse" :message="refreshRecaptchaString"></ReCaptcha>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="login">Login</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <div class="footerText">{{footer}}</div>
        </v-content>

        <v-snackbar v-model="snackBarEnabled" :centered="true" color="cyan darken-1">
            <span style="font-size:10pt; font-weight:bold">
            {{snackBarContent}}
            </span>
            <template v-slot:action="{attrs}">
                <v-btn
                    text
                    v-bind="attrs"
                    @click="snackBarEnabled=false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-app>

</template>

<style>
    .v-menu__content {
        min-width: auto !important;
    }

    .v-card.v-sheet>.v-card__title>.v-image.v-responsive.mx-auto {
        flex: unset;
    }

    .loginLabel .v-label {
        font-size: 23px !important;
        top: -5px !important;
    }

    .fr-wrapper {
        min-height: 200px;
    }

    #eventionAdminPortal .primary,  #eventionAdminPortal button.red{
        color: white !important;
        font-weight: bold;
    }

    #eventionAdminPortal .primaryBackgroundColor {
        /* background-color: rgba(150, 150, 150, 0.1) !important; */
        background-color: #F4F4F4 !important;
    }
    #eventionAdminPortal .footerText {
        font-size: 14px !important;
        position: fixed;
        bottom: 0px;
        right: 0px;
        padding: 2px 4px;
        border-radius: 5px 0 0 0;
        backdrop-filter: blur(10px);
    }

    #eventionAdminPortal .portalContainer {
        margin-bottom: 30px !important;
    }
    
    .theme--light.v-input input[readonly] {
        color: #888;
    }
    
    .v-dialog.guestEditDialogDesktop {
        margin: 80px 20px 20px 20px !important;
        max-height: calc(100% - 100px) !important;
    }
    
    .v-dialog.guestEditDialogMobile {
        margin: 110px 0 0 0 !important;
        max-height: calc(100% - 110px) !important;
    }
    
    .popup-editor-container {
        height: 20rem;
        overflow-y: auto;
    }

    .popup-preview {
        height: 80px;
        overflow-y: auto;
    }

    .theme--light.v-card > .v-card__text, .theme--light.v-card .v-card__subtitle {
        color: black !important;
    }
</style>

<script>

    import AppDrawer from "./components/AppDrawer";
    import ReCaptcha from "./components/ReCaptcha.vue";

    export default {
        name: 'App',
        components: {AppDrawer, ReCaptcha},
        data: () => ({
            loginDialogShown: false,
            username: '',
            password: '',
            showPassword: false,

            drawerShown: false,

            snackBarContent: null,
            snackBarEnabled: false,

            footer: '',

            reCaptchaResponse: null,
            refreshRecaptcha: 0,
            refreshRecaptchaString: '0'
        }),

        beforeCreate() {
            this.$store.dispatch('getServerTime').then((m)=>{
                const currentYear = (parseInt(m) ? new Date(parseInt(m)).getFullYear() : '2020');
                this.footer = `Copyright \u00A9  ${currentYear}  EVENTION. All Right Reserved.`;
            });
        },
        created() {
            // this.$vuetify.theme.dark = true
        },

        mounted() {
            const t = this.$route.query.t;
            if (t) {
                this.apilogin = true;
                this.$store.dispatch('auth/authenticate', {
                    strategy: 'jwt',
                    accessToken: t
                }).then(() => {
                    this.loginDialogShown = false;
                    this.$router.replace({'query': null});
                    window.location.reload();
                }, (e) => {
                    this.loginDialogShown = true;
                    window.location.href = '/#/event/';

                    if (!e.message.includes('Could not find stored JWT')) {
                        console.error(e)
                    }
                })
            } else {
                this.apilogin = false;
                this.$store.dispatch('auth/authenticate').then(() => {
                    this.loginDialogShown = false;
                }, (error) => {
                    this.loginDialogShown = true;
                    window.location.href = '/#/event/';
                    if (!error.message.includes('Could not find stored JWT')) {
                        console.error(error)
                    }
                });
            }
            this.drawerShown = this.$vuetify.breakpoint.mdAndUp;
        },

        computed: {
            storeSnackBarContent() {
                return this.$store.state.snackBarContent;
            },
            /*showUserName() {
                if (this.$store.state.auth.user != null && this.$store.state.auth.user.email != null)
                    return this.$store.state.auth.user.email.split('@')[0];
                else
                    return "";
            },*/
            loggedInUser() {
                return this.$store.state.auth.user;
            },
            eventId() {
                return this.$route.params.eventId;
            }
        },

        watch: {
            storeSnackBarContent(newValue) {
                this.snackBarContent = newValue;
                if (newValue) {
                    this.snackBarEnabled = true;
                }
            },
            snackBarEnabled(newVal) {
                if (!newVal) {
                    this.$store.dispatch('showSnackBar', null);
                }
            },
            loggedInUser() {
                // console.log(this.$store.state.auth.user);
                if (this.$store.state.auth.user && this.$store.state.auth.user.company) this.$store.commit('setPrefilledCompanyId', this.$store.state.auth.user.company.id);
            },
            eventId(eventId) {
                if (!eventId) {
                    document.querySelector('#event-name').innerHTML = '';
                }
            }
        },

        methods: {
            login() {
                this.$store.dispatch('auth/authenticate', {
                    strategy: 'local',
                    email: this.username,
                    password: this.password,
                    reCaptcha_token: this.reCaptchaResponse
                }).then(() => {
                    window.location.reload();
                }, (e) => {
                    this.refreshRecaptcha++;
                    this.refreshRecaptchaString = this.refreshRecaptcha.toString();
                    this.$handleFeatherError(e);
                })
            },
            logout() {
                this.$store.dispatch('auth/logout').then(() => {
                    window.location.reload();
                });
            },
            updateReCaptchaResponse(response) {
                this.reCaptchaResponse = response;
            }
        },
    };
</script>
